/**
 * The ONLY classes in the application that use the reserved `live` colour tokens.
 *
 * Everything Live-coloured imports from here or from the components in this folder, and
 * the token-usage test (tokens.test.ts) fails if a `live` token appears anywhere else.
 * The accent is never used on a Live affordance: focus rings here are `live` too.
 */
export const LIVE_NAV_ITEM = 'text-live-ink focus-visible:outline-live';
export const LIVE_NAV_ITEM_ACTIVE = 'bg-live-soft text-live-ink font-semibold';
export const LIVE_NAV_ICON = 'text-live';
export const LIVE_TAB_ACTIVE = 'text-live-ink';
export const LIVE_FILL = 'bg-live text-ink-on-live';
export const LIVE_SOFT = 'bg-live-soft text-live-ink';
export const LIVE_BORDER = 'border-live';
export const LIVE_FOCUS = 'focus-visible:outline-live';
